module.exports = __webpack_public_path__ + "static/chatbot-5a1d45f8810a1bc468bf99f16fbf032c.svg";